import { defineMessages } from 'react-intl';

export default defineMessages({
  tryAgainMessage: {
    id: 'frontbucket.jiraPage.errorState.tryAgainMessage',
    description: 'Try again message',
    defaultMessage: 'Try again in a few seconds.',
  },
  retryButtonLabel: {
    id: 'frontbucket.jiraPage.errorState.retryButtonLabel',
    description: 'Retry button label to fetch issues again',
    defaultMessage: 'Try again',
  },
});
